module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASBAMAAABCyVggAAAAAXNSR0IB2cksfwAAAA9QTFRFAAAAAAAAAAAAAAAAAAAATw7njQAAAAV0Uk5TANDPEP8ZDJOJAAAANUlEQVR4nGNgAANGZQYEYHQyQHCYRZClDMmWEnGBAwVkjgBCmZEjwgRmFWFKJBiRJBgYwRIAa3YL9POQZvoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/right-arrow.png
// module id = 895
// module chunks = 0